import { Button, Modal } from 'antd';
import React from 'react';
import usecustomStyles from './customStyles';
import { Trash2 } from 'lucide-react';

const customStyles = usecustomStyles();

export const DeleteModal = ({ show, handleClose, deleteModalFunction }) => {
    const style4Cancele = { backgroundColor: customStyles.colorBgContainer, color: customStyles.colorSuccess, marginRight: customStyles.margin };
    return (
        <React.Fragment>
            <Modal
                centered
                open={show}
                onCancel={handleClose}
                footer={[
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Button type="primary" style={style4Cancele} onClick={handleClose}>
                            取消
                        </Button>
                        <Button type="primary" style={{ backgroundColor: customStyles.colorDanger }} onClick={deleteModalFunction}>
                            确定删除
                        </Button>
                    </div>
                ]}
            >
                <div style={{ marginBottom: customStyles.margin }} className="text-center">
                    <div>
                        <Trash2 style={{ color: customStyles.colorDanger, marginTop: customStyles.margin }} size={80} />
                    </div>
                    <div style={{ marginTop: customStyles.marginSM }}>
                        <h4 style={{ fontSize: customStyles.h4 }}>你确定吗 ？</h4>
                        <p className="text-muted mx-4 mb-0">您确定要删除此数据吗 ？</p>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
};
